import { ActionTree } from 'vuex';

import { getRequestPaymentInfo, getPayLink, getSbpPayLink, getContractHtml, confirmContract  } from '@/api/requestPayment';

export default {
  actions: <ActionTree<any, any>>{
    async getRequestPaymentInfo(
      context,
      token
    ) {
      const response = await getRequestPaymentInfo(token);
      return response;
    },

    async getPayLink(
      context,
      token
    ) {
      const response = await getPayLink(token);
      return response;
    },

    async getSbpPayLink(
      context,
      token
    ) {
      const response = await getSbpPayLink(token);
      return response;
    },

    async getContractHtml(
      context,
      token
    ) {
      const response = await getContractHtml(token);
      return response;
    },

    async confirmContract(
      context,
      token
    ) {
      const response = await confirmContract(token);
      return response;
    }
  }
}